function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="currentColor" {...props}><path d="M.844 3.688h19.408a.843.843 0 1 0 0-1.688H.844a.843.843 0 1 0 0 1.688zm0 8h19.408a.843.843 0 1 0 0-1.688H.844a.843.843 0 1 0 0 1.688zm19.408 6.601H.914a.843.843 0 1 0 0 1.688h19.338a.843.843 0 1 0 0-1.688z" /></svg>;
});